<!-- Page Header Start -->
<div class="page-main-header" [ngClass]="{ open: navServices.collapseSidebar }" id="page-main-header">
  <div class="main-header-right d-flex justify-content-between align-items-center row">
    
    <!-- Sidebar Collapse & Title + Breadcrumb Section -->
    <div class="d-flex align-items-center col-auto p-0">
      <div class="mobile-sidebar">
        <div class="switch-sm">
          <label class="switch">
            <a href="javascript:void(0)" (click)="collapseSidebar()">
              <app-feather-icons id="sidebar-toggle" [icon]="'align-left'"></app-feather-icons>
            </a>
          </label>&nbsp;
          <!-- <label class="switch">
            <a [routerLink]="'/dashboard'">
              <app-feather-icons [icon]="'home'" ></app-feather-icons>
            </a>
          </label> -->
        </div>
           
          
        
      </div>

      <div class="page-header-left d-flex align-items-center ms-3" >
        <h3 class="header-title mb-0">
          {{ headerTitle | translate }} 
          <ng-container *ngIf="(breadcrumbs?.parentBreadcrumb || breadcrumbs?.childBreadcrumb)">
            /
          </ng-container>
          {{ (breadcrumbs?.parentBreadcrumb | translate) || (breadcrumbs?.childBreadcrumb | translate) }}
        </h3>
        <h3 class="header-title mb-0">
          <!-- &nbsp; / {{ breadcrumbs?.parentBreadcrumb || breadcrumbs?.childBreadcrumb }} -->
        </h3>
      </div>
      
    </div>
    
    <!-- Profile Section -->
    <div class="nav-right col-auto">
      <ul class="nav-menus d-flex align-items-center">
        <li class="onhover-dropdown">
          <a class="txt-dark" href="javascript:void(0)">
            <h6>{{ currentLanguage }}</h6>
          </a>
          <ul class="language-dropdown onhover-show-div p-20">
            <li>
              <a href="javascript:void(0)" data-lng="en" (click)="changeLanguage('en')"><i
                  class="flag-icon flag-icon-is"></i> English</a>
            </li>
            <li>
              <li>
                <a href="javascript:void(0)" data-lng="ae" (click)="changeLanguage('ar')"><i
                    class="flag-icon flag-icon-ae"></i> Arabic</a>
              </li>
              <li>
              <!-- <a href="javascript:void(0)" data-lng="es" (click)="changeLanguage('es')"><i
                  class="flag-icon flag-icon-um"></i> Spanish</a>
            </li>
            <li>
              <a href="javascript:void(0)" data-lng="pt" (click)="changeLanguage('pt')"><i
                  class="flag-icon flag-icon-uy"></i> Portuguese</a>
            </li>
            <li>
              <a href="javascript:void(0)" data-lng="fr" (click)="changeLanguage('fr')"><i
                  class="flag-icon flag-icon-nz"></i> French</a>
            </li> -->
          </ul>
        </li>
        <li class="onhover-dropdown">
          <div class="media align-items-center">
            <img class="img-50 rounded-circle" src="assets/images/dashboard/defalt_image.jpg" alt="header-user" />
            <div class="dotted-animation">
              <!-- <span class="animate-circle"></span><span class="main-circle"></span> -->
            </div>
          </div>
          
          <ul class="profile-dropdown onhover-show-div p-20">
            <li>
              <a href="javascript:void(0)" (click)="gotoProfileSetting()">
                <app-feather-icons [icon]="'user'"></app-feather-icons>Edit Profile
              </a>
            </li>
            <li>
              <a href="javascript:void(0)" (click)="ChangePassword()">
                <i class="icofont icofont-key"></i>&nbsp;&nbsp;Password
              </a>
            </li>
            <li>
              <a href="javascript:void(0)" (click)="logout()">
                <app-feather-icons [icon]="'log-out'"></app-feather-icons>Logout
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    
  </div>
</div>
<!-- Page Header Ends -->
